
import {defineComponent} from 'vue';
import {toastMixin} from './toast-mixin';
import {ToastType, ICON_MAP} from './types';
import Icon from '@ohrm/oxd/core/components/Icon/Icon.vue';

export default defineComponent({
  name: 'oxd-toast-icon',

  mixins: [toastMixin],

  components: {
    'oxd-icon': Icon,
  },

  computed: {
    iconWrapClasses(): object {
      return {
        'oxd-toast-icon-wrap': true,
        [`oxd-toast-icon-wrap--${this.type}`]: true,
      };
    },
    iconName(): string {
      return ICON_MAP[this.type as ToastType];
    },
  },
});
